import React, { createContext, useContext, useState, useEffect } from 'react';

// Translation objects
const translations = {
  en: {
    // Navigation
    dashboard: 'Dashboard',
    profiles: 'Profiles',
    publicProfiles: 'Public Profiles',
    savedProfiles: 'Saved Profiles',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    
    // Profile Actions
    edit: 'Edit',
    delete: 'Delete',
    deactivate: 'Deactivate',
    shareOnWhatsApp: 'Share on WhatsApp',
    
    // Profile Fields
    fullName: 'Full Name',
    contactNumber: 'Contact Number',
    age: 'Age',
    gender: 'Gender',
    height: 'Height',
    maritalStatus: 'Marital Status',
    city: 'City',
    profession: 'Profession',
    education: 'Education',
    caste: 'Caste',
    monthlyIncome: 'Monthly Income',
    houseSize: 'House Size',
    area: 'Area',
    country: 'Country',
    
    // Form Labels
    search: 'Search',
    filter: 'Filter',
    refresh: 'Refresh',
    addUser: 'Add Profile',
    save: 'Save',
    cancel: 'Cancel',
    
    // Messages
    loading: 'Loading...',
    userCreated: 'User created successfully.',
    userUpdated: 'User updated successfully.',
    userDeleted: 'User deleted successfully.',
    
    // Gender Options
    male: 'Male',
    female: 'Female',
    
    // Marital Status
    single: 'Single',
    divorced: 'Divorced',
    widowed: 'Widowed',
    separated: 'Separated',
    
    // House Status
    rent: 'Rent',
    own: 'Own',
    
    // Common
    notSpecified: 'Not specified',
    years: 'years',
    feet: 'ft',
    inches: 'in',
    marla: 'marla',
    viewProfile: 'View Profile',
    sharedVia: 'Shared via Phuphoo Marriage Bureau',
    
    // Dashboard descriptions
    exploreProfiles: 'Explore active profiles from all marriage bureaus',
    cardViewDescription: 'Every client profile your bureau manages. Search, filter, and click any card to view complete details or take action.',
    tableViewDescription: 'Table view for easy comparison — good for scannable data.',
    
    // Profile Card Fields
    personalDetails: 'Personal Details:',
    dateOfBirth: 'Date of Birth:',
    house: 'House:',
    qualification: 'Qualification:',
    familyInformation: 'Family Information:',
    parentsDetails: 'Parents Details:',
    father: 'Father:',
    mother: 'Mother:',
    id: 'ID:',
  },
  
  ur: {
    // Navigation
    dashboard: 'ڈیش بورڈ',
    profiles: 'پروفائلز',
    publicProfiles: 'عوامی پروفائلز',
    savedProfiles: 'محفوظ شدہ پروفائلز',
    login: 'لاگ ان',
    register: 'رجسٹر',
    logout: 'لاگ آؤٹ',
    
    // Profile Actions
    edit: 'ترمیم',
    delete: 'حذف کریں',
    deactivate: 'غیر فعال کریں',
    shareOnWhatsApp: 'واٹس ایپ پر شیئر کریں',
    
    // Profile Fields
    fullName: 'پورا نام',
    contactNumber: 'رابطہ نمبر',
    age: 'عمر',
    gender: 'جنس',
    height: 'قد',
    maritalStatus: 'شادی کی حیثیت',
    city: 'شہر',
    profession: 'پیشہ',
    education: 'تعلیم',
    caste: 'ذات',
    monthlyIncome: 'ماہانہ آمدنی',
    houseSize: 'گھر کی جگہ',
    area: 'علاقہ',
    country: 'ملک',
    
    // Form Labels
    search: 'تلاش کریں',
    filter: 'فلٹر',
    refresh: 'ریفریش',
    addUser: 'پروفائل شامل کریں',
    save: 'محفوظ کریں',
    cancel: 'منسوخ کریں',
    card: 'کارڈ',
    table: 'ٹیبل',
    showDeactivated: 'غیر فعال شدہ دکھائیں',
    
    // Messages
    loading: 'لوڈ ہو رہا ہے...',
    userCreated: 'صارف کامیابی سے بنایا گیا۔',
    userUpdated: 'صارف کامیابی سے اپ ڈیٹ کیا گیا۔',
    userDeleted: 'صارف کامیابی سے حذف ہو گیا۔',
    
    // Gender Options
    male: 'مرد',
    female: 'خاتون',
    
    // Marital Status
    single: 'غیر شادی شدہ',
    divorced: 'طلاق شدہ',
    widowed: 'بیوہ',
    separated: 'الگ ہو گیا',
    
    // House Status
    rent: 'کرایہ پر',
    own: 'اپنا',
    
    // Common
    notSpecified: 'محدود نہیں',
    years: 'سال',
    feet: 'فٹ',
    inches: 'انچ',
    marla: 'مرلہ',
    viewProfile: 'پروفائل دیکھیں',
    sharedVia: 'فپھو شادی بیورو کے ذریعے شیئر کیا گیا',
    
    // Dashboard descriptions
    exploreProfiles: 'تمام شادی بیوروں سے فعال پروفائلز تلاش کریں',
    cardViewDescription: 'آپ کے بیورو کے زیر انتظام ہر کلائنٹ پروفائل۔ تلاش کریں، فلٹر کریں، اور مکمل تفصیلات یا کارروائی کے لیے کسی بھی کارڈ پر کلک کریں۔',
    tableViewDescription: 'ٹیبل ویو - آسانی موازنہ کے لیے اچھی ہے — قابل اسکین کے لیے ڈیٹا۔',
    
    // Profile Card Fields
    personalDetails: 'ذاتی تفصیلات:',
    dateOfBirth: 'تاریخ پیدائش:',
    house: 'گھر:',
    qualification: 'تعیین:',
    familyInformation: 'خاندانی معلومات:',
    parentsDetails: 'والدین کی تفصیلات:',
    father: 'والد:',
    mother: 'والدہ:',
    id: 'شناختی:',
  }
};

// Create context
const LanguageContext = createContext();

// Language provider component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en'); // Default to English
  
  // Load saved language preference on mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setLanguage(savedLanguage);
  }, []);
  
  // Save language preference when it changes
  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };
  
  // Translation function
  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };
  
  const isRTL = language === 'ur';
  
  const value = {
    language,
    changeLanguage,
    t,
    isRTL,
  };
  
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook to use language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;